<script>
  import Footer from "@/components/Footer.vue";

  export default {
    name: "AppContact",
    components: {
      Footer
    },
    mounted() {
      window.addEventListener('keydown', this.handleEscapeKey);
    },
    methods: {
      handleEscapeKey(event) {
        if (event.key === "Escape") {
          this.$router.push('/'); // Redirection vers la page d'accueil
        }
      }
    }
  }
</script>

<template>
  <div id="contact-ctn">
    <nav>
      <div class="back-btn">
        <router-link to="/"><img src="@/assets/images/icon/back.svg" alt="back-btn"></router-link>
      </div>
    </nav>

    <div id="contact">
      <h1>Contactez-moi !</h1>
      <div class="contact-info">
        <p><strong>Email :</strong> <a href="mailto:numaverpillon42@gmail.com">numaverpillon42@gmail.com</a></p>
        <p><strong>Téléphone :</strong> 06 44 30 40 23</p>
      </div>

      <h2>Réseau</h2>
      <div class="social-links">
        <p><a href="https://www.malt.fr/profile/numaverpillon" target="_blank">🤝 Malt</a></p>
      </div>
    </div>
    <div>
      <Footer />
    </div>
  </div>
</template>

<style>
  #contact-ctn {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100vh;
  }

  #contact {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: left;
  }

  #contact h1{
    font-size: 3.2em;
    text-transform: uppercase;
  }

  #contact h2{
    margin-top: 8vh;
    margin-bottom: 2vh;
    font-size: 2.2em;
  }

  #contact p{
    font-size: 1.5em;
  }
</style>